import * as React from 'react'

interface RewardIconProps {
  color: string
  className?: string
}

const RewardIcon: React.FunctionComponent<RewardIconProps> = ({ className, color }) => {
  const style = {
    fill: color,
  }

  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 30 30">
      <g transform="translate(-0.004)">
        <g transform="translate(3.127)">
          <path
            style={style}
            d="M86.864,0a6.872,6.872,0,1,0,6.872,6.872A6.88,6.88,0,0,0,86.864,0Zm3.612,5.9L89.29,7.387l.13,1.943a.622.622,0,0,1-.262.551.63.63,0,0,1-.362.115.612.612,0,0,1-.244-.05L86.864,9.23l-1.686.716a.625.625,0,0,1-.868-.616l.13-1.943L83.253,5.9a.625.625,0,0,1,.33-.995l1.772-.464.972-1.637a.648.648,0,0,1,1.073,0l.972,1.637,1.773.464a.626.626,0,0,1,.331.995Z"
            transform="translate(-79.992)"
          />
        </g>
        <g transform="translate(0.004 10.925)">
          <path
            style={style}
            d="M2.971,279.776.087,284.783a.625.625,0,0,0,.7.916l3.669-.986.976,3.669a.626.626,0,0,0,.521.459c.027,0,.056,0,.082,0a.625.625,0,0,0,.541-.312l2.728-4.721A8.125,8.125,0,0,1,2.971,279.776Z"
            transform="translate(-0.004 -279.776)"
          />
        </g>
        <g transform="translate(10.692 10.925)">
          <path
            style={style}
            d="M282.942,284.783l-2.885-5.007a8.123,8.123,0,0,1-6.336,4.035l2.728,4.721a.625.625,0,0,0,.541.312.589.589,0,0,0,.081-.005.628.628,0,0,0,.522-.459l.976-3.669,3.669.986a.625.625,0,0,0,.7-.915Z"
            transform="translate(-273.72 -279.776)"
          />
        </g>
      </g>
    </svg>
  )
}

export default RewardIcon
